import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/minus.png'
import _imports_1 from '../assets/plus.png'


const _withScopeId = n => (_pushScopeId("data-v-351d314c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bright-box" }
const _hoisted_2 = { class: "left-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Jasność", -1))
const _hoisted_4 = { class: "center-box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "minus"
}, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "plus"
}, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "right-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", null, _toDisplayString(this.data), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.changeBright(-1)))
      }, _hoisted_6),
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.changeBright(1)))
      }, _hoisted_8)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("button", {
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($options.setBrightness(this.data)))
      }, "Ustaw")
    ])
  ]))
}